var gsl_const = {};

gsl_const.CGS = {};
gsl_const.CGS.SPEED_OF_LIGHT =  2.99792458e+10; /* cm / s */
gsl_const.CGS.GRAVITATIONAL_CONSTANT =  6.673e-8; /* cm^3 / g s^2 */
gsl_const.CGS.PLANCKS_CONSTANT_H =  6.62606896e-27; /* g cm^2 / s */
gsl_const.CGS.PLANCKS_CONSTANT_HBAR =  1.05457162825e-27; /* g cm^2 / s */
gsl_const.CGS.ASTRONOMICAL_UNIT =  1.49597870691e+13; /* cm */
gsl_const.CGS.LIGHT_YEAR =  9.46053620707e+17; /* cm */
gsl_const.CGS.PARSEC =  3.08567758135e+18; /* cm */
gsl_const.CGS.GRAV_ACCEL =  9.80665e+2; /* cm / s^2 */
gsl_const.CGS.ELECTRON_VOLT =  1.602176487e-12; /* g cm^2 / s^2 */
gsl_const.CGS.MASS_ELECTRON =  9.10938188e-28; /* g */
gsl_const.CGS.MASS_MUON =  1.88353109e-25; /* g */
gsl_const.CGS.MASS_PROTON =  1.67262158e-24; /* g */
gsl_const.CGS.MASS_NEUTRON =  1.67492716e-24; /* g */
gsl_const.CGS.RYDBERG =  2.17987196968e-11; /* g cm^2 / s^2 */
gsl_const.CGS.BOLTZMANN =  1.3806504e-16; /* g cm^2 / K s^2 */
gsl_const.CGS.MOLAR_GAS =  8.314472e7; /* g cm^2 / K mol s^2 */
gsl_const.CGS.STANDARD_GAS_VOLUME =  2.2710981e4; /* cm^3 / mol */
gsl_const.CGS.MINUTE =  6e1; /* s */
gsl_const.CGS.HOUR =  3.6e3; /* s */
gsl_const.CGS.DAY =  8.64e4; /* s */
gsl_const.CGS.WEEK =  6.048e5; /* s */
gsl_const.CGS.INCH =  2.54e0; /* cm */
gsl_const.CGS.FOOT =  3.048e1; /* cm */
gsl_const.CGS.YARD =  9.144e1; /* cm */
gsl_const.CGS.MILE =  1.609344e5; /* cm */
gsl_const.CGS.NAUTICAL_MILE =  1.852e5; /* cm */
gsl_const.CGS.FATHOM =  1.8288e2; /* cm */
gsl_const.CGS.MIL =  2.54e-3; /* cm */
gsl_const.CGS.POINT =  3.52777777778e-2; /* cm */
gsl_const.CGS.TEXPOINT =  3.51459803515e-2; /* cm */
gsl_const.CGS.MICRON =  1e-4; /* cm */
gsl_const.CGS.ANGSTROM =  1e-8; /* cm */
gsl_const.CGS.HECTARE =  1e8; /* cm^2 */
gsl_const.CGS.ACRE =  4.04685642241e7; /* cm^2 */
gsl_const.CGS.BARN =  1e-24; /* cm^2 */
gsl_const.CGS.LITER =  1e3; /* cm^3 */
gsl_const.CGS.US_GALLON =  3.78541178402e3; /* cm^3 */
gsl_const.CGS.QUART =  9.46352946004e2; /* cm^3 */
gsl_const.CGS.PINT =  4.73176473002e2; /* cm^3 */
gsl_const.CGS.CUP =  2.36588236501e2; /* cm^3 */
gsl_const.CGS.FLUID_OUNCE =  2.95735295626e1; /* cm^3 */
gsl_const.CGS.TABLESPOON =  1.47867647813e1; /* cm^3 */
gsl_const.CGS.TEASPOON =  4.92892159375e0; /* cm^3 */
gsl_const.CGS.CANADIAN_GALLON =  4.54609e3; /* cm^3 */
gsl_const.CGS.UK_GALLON =  4.546092e3; /* cm^3 */
gsl_const.CGS.MILES_PER_HOUR =  4.4704e1; /* cm / s */
gsl_const.CGS.KILOMETERS_PER_HOUR =  2.77777777778e1; /* cm / s */
gsl_const.CGS.KNOT =  5.14444444444e1; /* cm / s */
gsl_const.CGS.POUND_MASS =  4.5359237e2; /* g */
gsl_const.CGS.OUNCE_MASS =  2.8349523125e1; /* g */
gsl_const.CGS.TON =  9.0718474e5; /* g */
gsl_const.CGS.METRIC_TON =  1e6; /* g */
gsl_const.CGS.UK_TON =  1.0160469088e6; /* g */
gsl_const.CGS.TROY_OUNCE =  3.1103475e1; /* g */
gsl_const.CGS.CARAT =  2e-1; /* g */
gsl_const.CGS.UNIFIED_ATOMIC_MASS =  1.660538782e-24; /* g */
gsl_const.CGS.GRAM_FORCE =  9.80665e2; /* cm g / s^2 */
gsl_const.CGS.POUND_FORCE =  4.44822161526e5; /* cm g / s^2 */
gsl_const.CGS.KILOPOUND_FORCE =  4.44822161526e8; /* cm g / s^2 */
gsl_const.CGS.POUNDAL =  1.38255e4; /* cm g / s^2 */
gsl_const.CGS.CALORIE =  4.1868e7; /* g cm^2 / s^2 */
gsl_const.CGS.BTU =  1.05505585262e10; /* g cm^2 / s^2 */
gsl_const.CGS.THERM =  1.05506e15; /* g cm^2 / s^2 */
gsl_const.CGS.HORSEPOWER =  7.457e9; /* g cm^2 / s^3 */
gsl_const.CGS.BAR =  1e6; /* g / cm s^2 */
gsl_const.CGS.STD_ATMOSPHERE =  1.01325e6; /* g / cm s^2 */
gsl_const.CGS.TORR =  1.33322368421e3; /* g / cm s^2 */
gsl_const.CGS.METER_OF_MERCURY =  1.33322368421e6; /* g / cm s^2 */
gsl_const.CGS.INCH_OF_MERCURY =  3.38638815789e4; /* g / cm s^2 */
gsl_const.CGS.INCH_OF_WATER =  2.490889e3; /* g / cm s^2 */
gsl_const.CGS.PSI =  6.89475729317e4; /* g / cm s^2 */
gsl_const.CGS.POISE =  1e0; /* g / cm s */
gsl_const.CGS.STOKES =  1e0; /* cm^2 / s */
gsl_const.CGS.STILB =  1e0; /* cd / cm^2 */
gsl_const.CGS.LUMEN =  1e0; /* cd sr */
gsl_const.CGS.LUX =  1e-4; /* cd sr / cm^2 */
gsl_const.CGS.PHOT =  1e0; /* cd sr / cm^2 */
gsl_const.CGS.FOOTCANDLE =  1.076e-3; /* cd sr / cm^2 */
gsl_const.CGS.LAMBERT =  1e0; /* cd sr / cm^2 */
gsl_const.CGS.FOOTLAMBERT =  1.07639104e-3; /* cd sr / cm^2 */
gsl_const.CGS.CURIE =  3.7e10; /* 1 / s */
gsl_const.CGS.ROENTGEN =  2.58e-7; /* A s / g */
gsl_const.CGS.RAD =  1e2; /* cm^2 / s^2 */
gsl_const.CGS.SOLAR_MASS =  1.98892e33; /* g */
gsl_const.CGS.BOHR_RADIUS =  5.291772083e-9; /* cm */
gsl_const.CGS.NEWTON =  1e5; /* cm g / s^2 */
gsl_const.CGS.DYNE =  1e0; /* cm g / s^2 */
gsl_const.CGS.JOULE =  1e7; /* g cm^2 / s^2 */
gsl_const.CGS.ERG =  1e0; /* g cm^2 / s^2 */
gsl_const.CGS.STEFAN_BOLTZMANN_CONSTANT =  5.67040047374e-5; /* g / K^4 s^3 */
gsl_const.CGS.THOMSON_CROSS_SECTION =  6.65245893699e-25; /* cm^2 */

gsl_const.CGSM = {};
gsl_const.CGSM.SPEED_OF_LIGHT = 2.99792458e10 /* cm / s */
gsl_const.CGSM.GRAVITATIONAL_CONSTANT = 6.673e-8 /* cm^3 / g s^2 */
gsl_const.CGSM.PLANCKS_CONSTANT_H = 6.62606896e-27 /* g cm^2 / s */
gsl_const.CGSM.PLANCKS_CONSTANT_HBAR = 1.05457162825e-27 /* g cm^2 / s */
gsl_const.CGSM.ASTRONOMICAL_UNIT = 1.49597870691e13 /* cm */
gsl_const.CGSM.LIGHT_YEAR = 9.46053620707e17 /* cm */
gsl_const.CGSM.PARSEC = 3.08567758135e18 /* cm */
gsl_const.CGSM.GRAV_ACCEL = 9.80665e2 /* cm / s^2 */
gsl_const.CGSM.ELECTRON_VOLT = 1.602176487e-12 /* g cm^2 / s^2 */
gsl_const.CGSM.MASS_ELECTRON = 9.10938188e-28 /* g */
gsl_const.CGSM.MASS_MUON = 1.88353109e-25 /* g */
gsl_const.CGSM.MASS_PROTON = 1.67262158e-24 /* g */
gsl_const.CGSM.MASS_NEUTRON = 1.67492716e-24 /* g */
gsl_const.CGSM.RYDBERG = 2.17987196968e-11 /* g cm^2 / s^2 */
gsl_const.CGSM.BOLTZMANN = 1.3806504e-16 /* g cm^2 / K s^2 */
gsl_const.CGSM.MOLAR_GAS = 8.314472e7 /* g cm^2 / K mol s^2 */
gsl_const.CGSM.STANDARD_GAS_VOLUME = 2.2710981e4 /* cm^3 / mol */
gsl_const.CGSM.MINUTE = 6e1 /* s */
gsl_const.CGSM.HOUR = 3.6e3 /* s */
gsl_const.CGSM.DAY = 8.64e4 /* s */
gsl_const.CGSM.WEEK = 6.048e5 /* s */
gsl_const.CGSM.INCH = 2.54e0 /* cm */
gsl_const.CGSM.FOOT = 3.048e1 /* cm */
gsl_const.CGSM.YARD = 9.144e1 /* cm */
gsl_const.CGSM.MILE = 1.609344e5 /* cm */
gsl_const.CGSM.NAUTICAL_MILE = 1.852e5 /* cm */
gsl_const.CGSM.FATHOM = 1.8288e2 /* cm */
gsl_const.CGSM.MIL = 2.54e-3 /* cm */
gsl_const.CGSM.POINT = 3.52777777778e-2 /* cm */
gsl_const.CGSM.TEXPOINT = 3.51459803515e-2 /* cm */
gsl_const.CGSM.MICRON = 1e-4 /* cm */
gsl_const.CGSM.ANGSTROM = 1e-8 /* cm */
gsl_const.CGSM.HECTARE = 1e8 /* cm^2 */
gsl_const.CGSM.ACRE = 4.04685642241e7 /* cm^2 */
gsl_const.CGSM.BARN = 1e-24 /* cm^2 */
gsl_const.CGSM.LITER = 1e3 /* cm^3 */
gsl_const.CGSM.US_GALLON = 3.78541178402e3 /* cm^3 */
gsl_const.CGSM.QUART = 9.46352946004e2 /* cm^3 */
gsl_const.CGSM.PINT = 4.73176473002e2 /* cm^3 */
gsl_const.CGSM.CUP = 2.36588236501e2 /* cm^3 */
gsl_const.CGSM.FLUID_OUNCE = 2.95735295626e1 /* cm^3 */
gsl_const.CGSM.TABLESPOON = 1.47867647813e1 /* cm^3 */
gsl_const.CGSM.TEASPOON = 4.92892159375e0 /* cm^3 */
gsl_const.CGSM.CANADIAN_GALLON = 4.54609e3 /* cm^3 */
gsl_const.CGSM.UK_GALLON = 4.546092e3 /* cm^3 */
gsl_const.CGSM.MILES_PER_HOUR = 4.4704e1 /* cm / s */
gsl_const.CGSM.KILOMETERS_PER_HOUR = 2.77777777778e1 /* cm / s */
gsl_const.CGSM.KNOT = 5.14444444444e1 /* cm / s */
gsl_const.CGSM.POUND_MASS = 4.5359237e2 /* g */
gsl_const.CGSM.OUNCE_MASS = 2.8349523125e1 /* g */
gsl_const.CGSM.TON = 9.0718474e5 /* g */
gsl_const.CGSM.METRIC_TON = 1e6 /* g */
gsl_const.CGSM.UK_TON = 1.0160469088e6 /* g */
gsl_const.CGSM.TROY_OUNCE = 3.1103475e1 /* g */
gsl_const.CGSM.CARAT = 2e-1 /* g */
gsl_const.CGSM.UNIFIED_ATOMIC_MASS = 1.660538782e-24 /* g */
gsl_const.CGSM.GRAM_FORCE = 9.80665e2 /* cm g / s^2 */
gsl_const.CGSM.POUND_FORCE = 4.44822161526e5 /* cm g / s^2 */
gsl_const.CGSM.KILOPOUND_FORCE = 4.44822161526e8 /* cm g / s^2 */
gsl_const.CGSM.POUNDAL = 1.38255e4 /* cm g / s^2 */
gsl_const.CGSM.CALORIE = 4.1868e7 /* g cm^2 / s^2 */
gsl_const.CGSM.BTU = 1.05505585262e10; /* g cm^2 / s^2 */
gsl_const.CGSM.THERM = 1.05506e15 /* g cm^2 / s^2 */
gsl_const.CGSM.HORSEPOWER = 7.457e9 /* g cm^2 / s^3 */
gsl_const.CGSM.BAR = 1e6 /* g / cm s^2 */
gsl_const.CGSM.STD_ATMOSPHERE = 1.01325e6 /* g / cm s^2 */
gsl_const.CGSM.TORR = 1.33322368421e3 /* g / cm s^2 */
gsl_const.CGSM.METER_OF_MERCURY = 1.33322368421e6 /* g / cm s^2 */
gsl_const.CGSM.INCH_OF_MERCURY = 3.38638815789e4 /* g / cm s^2 */
gsl_const.CGSM.INCH_OF_WATER = 2.490889e3 /* g / cm s^2 */
gsl_const.CGSM.PSI = 6.89475729317e4 /* g / cm s^2 */
gsl_const.CGSM.POISE = 1e0 /* g / cm s */
gsl_const.CGSM.STOKES = 1e0 /* cm^2 / s */
gsl_const.CGSM.STILB = 1e0 /* cd / cm^2 */
gsl_const.CGSM.LUMEN = 1e0 /* cd sr */
gsl_const.CGSM.LUX = 1e-4 /* cd sr / cm^2 */
gsl_const.CGSM.PHOT = 1e0 /* cd sr / cm^2 */
gsl_const.CGSM.FOOTCANDLE = 1.076e-3 /* cd sr / cm^2 */
gsl_const.CGSM.LAMBERT = 1e0 /* cd sr / cm^2 */
gsl_const.CGSM.FOOTLAMBERT = 1.07639104e-3 /* cd sr / cm^2 */
gsl_const.CGSM.CURIE = 3.7e10; /* 1 / s */
gsl_const.CGSM.ROENTGEN = 2.58e-8 /* abamp s / g */
gsl_const.CGSM.RAD = 1e2 /* cm^2 / s^2 */
gsl_const.CGSM.SOLAR_MASS = 1.98892e33 /* g */
gsl_const.CGSM.BOHR_RADIUS = 5.291772083e-9 /* cm */
gsl_const.CGSM.NEWTON = 1e5 /* cm g / s^2 */
gsl_const.CGSM.DYNE = 1e0 /* cm g / s^2 */
gsl_const.CGSM.JOULE = 1e7 /* g cm^2 / s^2 */
gsl_const.CGSM.ERG = 1e0 /* g cm^2 / s^2 */
gsl_const.CGSM.STEFAN_BOLTZMANN_CONSTANT = 5.67040047374e-5 /* g / K^4 s^3 */
gsl_const.CGSM.THOMSON_CROSS_SECTION = 6.65245893699e-25 /* cm^2 */
gsl_const.CGSM.BOHR_MAGNETON = 9.27400899e-21 /* abamp cm^2 */
gsl_const.CGSM.NUCLEAR_MAGNETON = 5.05078317e-24 /* abamp cm^2 */
gsl_const.CGSM.ELECTRON_MAGNETIC_MOMENT = 9.28476362e-21 /* abamp cm^2 */
gsl_const.CGSM.PROTON_MAGNETIC_MOMENT = 1.410606633e-23 /* abamp cm^2 */
gsl_const.CGSM.FARADAY = 9.64853429775e3 /* abamp s / mol */
gsl_const.CGSM.ELECTRON_CHARGE = 1.602176487e-20 /* abamp s */


gsl_const.MKS = {};
gsl_const.MKS.SPEED_OF_LIGHT = 2.99792458e8 /* m / s */
gsl_const.MKS.GRAVITATIONAL_CONSTANT = 6.673e-11 /* m^3 / kg s^2 */
gsl_const.MKS.PLANCKS_CONSTANT_H = 6.62606896e-34 /* kg m^2 / s */
gsl_const.MKS.PLANCKS_CONSTANT_HBAR = 1.05457162825e-34 /* kg m^2 / s */
gsl_const.MKS.ASTRONOMICAL_UNIT = 1.49597870691e11 /* m */
gsl_const.MKS.LIGHT_YEAR = 9.46053620707e15 /* m */
gsl_const.MKS.PARSEC = 3.08567758135e16 /* m */
gsl_const.MKS.GRAV_ACCEL = 9.80665e0 /* m / s^2 */
gsl_const.MKS.ELECTRON_VOLT = 1.602176487e-19 /* kg m^2 / s^2 */
gsl_const.MKS.MASS_ELECTRON = 9.10938188e-31 /* kg */
gsl_const.MKS.MASS_MUON = 1.88353109e-28 /* kg */
gsl_const.MKS.MASS_PROTON = 1.67262158e-27 /* kg */
gsl_const.MKS.MASS_NEUTRON = 1.67492716e-27 /* kg */
gsl_const.MKS.RYDBERG = 2.17987196968e-18 /* kg m^2 / s^2 */
gsl_const.MKS.BOLTZMANN = 1.3806504e-23 /* kg m^2 / K s^2 */
gsl_const.MKS.MOLAR_GAS = 8.314472e0 /* kg m^2 / K mol s^2 */
gsl_const.MKS.STANDARD_GAS_VOLUME = 2.2710981e-2 /* m^3 / mol */
gsl_const.MKS.MINUTE = 6e1 /* s */
gsl_const.MKS.HOUR = 3.6e3 /* s */
gsl_const.MKS.DAY = 8.64e4 /* s */
gsl_const.MKS.WEEK = 6.048e5 /* s */
gsl_const.MKS.INCH = 2.54e-2 /* m */
gsl_const.MKS.FOOT = 3.048e-1 /* m */
gsl_const.MKS.YARD = 9.144e-1 /* m */
gsl_const.MKS.MILE = 1.609344e3 /* m */
gsl_const.MKS.NAUTICAL_MILE = 1.852e3 /* m */
gsl_const.MKS.FATHOM = 1.8288e0 /* m */
gsl_const.MKS.MIL = 2.54e-5 /* m */
gsl_const.MKS.POINT = 3.52777777778e-4 /* m */
gsl_const.MKS.TEXPOINT = 3.51459803515e-4 /* m */
gsl_const.MKS.MICRON = 1e-6 /* m */
gsl_const.MKS.ANGSTROM = 1e-10 /* m */
gsl_const.MKS.HECTARE = 1e4 /* m^2 */
gsl_const.MKS.ACRE = 4.04685642241e3 /* m^2 */
gsl_const.MKS.BARN = 1e-28 /* m^2 */
gsl_const.MKS.LITER = 1e-3 /* m^3 */
gsl_const.MKS.US_GALLON = 3.78541178402e-3 /* m^3 */
gsl_const.MKS.QUART = 9.46352946004e-4 /* m^3 */
gsl_const.MKS.PINT = 4.73176473002e-4 /* m^3 */
gsl_const.MKS.CUP = 2.36588236501e-4 /* m^3 */
gsl_const.MKS.FLUID_OUNCE = 2.95735295626e-5 /* m^3 */
gsl_const.MKS.TABLESPOON = 1.47867647813e-5 /* m^3 */
gsl_const.MKS.TEASPOON = 4.92892159375e-6 /* m^3 */
gsl_const.MKS.CANADIAN_GALLON = 4.54609e-3 /* m^3 */
gsl_const.MKS.UK_GALLON = 4.546092e-3 /* m^3 */
gsl_const.MKS.MILES_PER_HOUR = 4.4704e-1 /* m / s */
gsl_const.MKS.KILOMETERS_PER_HOUR = 2.77777777778e-1 /* m / s */
gsl_const.MKS.KNOT = 5.14444444444e-1 /* m / s */
gsl_const.MKS.POUND_MASS = 4.5359237e-1 /* kg */
gsl_const.MKS.OUNCE_MASS = 2.8349523125e-2 /* kg */
gsl_const.MKS.TON = 9.0718474e2 /* kg */
gsl_const.MKS.METRIC_TON = 1e3 /* kg */
gsl_const.MKS.UK_TON = 1.0160469088e3 /* kg */
gsl_const.MKS.TROY_OUNCE = 3.1103475e-2 /* kg */
gsl_const.MKS.CARAT = 2e-4 /* kg */
gsl_const.MKS.UNIFIED_ATOMIC_MASS = 1.660538782e-27 /* kg */
gsl_const.MKS.GRAM_FORCE = 9.80665e-3 /* kg m / s^2 */
gsl_const.MKS.POUND_FORCE = 4.44822161526e0 /* kg m / s^2 */
gsl_const.MKS.KILOPOUND_FORCE = 4.44822161526e3 /* kg m / s^2 */
gsl_const.MKS.POUNDAL = 1.38255e-1 /* kg m / s^2 */
gsl_const.MKS.CALORIE = 4.1868e0 /* kg m^2 / s^2 */
gsl_const.MKS.BTU = 1.05505585262e3 /* kg m^2 / s^2 */
gsl_const.MKS.THERM = 1.05506e8 /* kg m^2 / s^2 */
gsl_const.MKS.HORSEPOWER = 7.457e2 /* kg m^2 / s^3 */
gsl_const.MKS.BAR = 1e5 /* kg / m s^2 */
gsl_const.MKS.STD_ATMOSPHERE = 1.01325e5 /* kg / m s^2 */
gsl_const.MKS.TORR = 1.33322368421e2 /* kg / m s^2 */
gsl_const.MKS.METER_OF_MERCURY = 1.33322368421e5 /* kg / m s^2 */
gsl_const.MKS.INCH_OF_MERCURY = 3.38638815789e3 /* kg / m s^2 */
gsl_const.MKS.INCH_OF_WATER = 2.490889e2 /* kg / m s^2 */
gsl_const.MKS.PSI = 6.89475729317e3 /* kg / m s^2 */
gsl_const.MKS.POISE = 1e-1 /* kg m^-1 s^-1 */
gsl_const.MKS.STOKES = 1e-4 /* m^2 / s */
gsl_const.MKS.STILB = 1e4 /* cd / m^2 */
gsl_const.MKS.LUMEN = 1e0 /* cd sr */
gsl_const.MKS.LUX = 1e0 /* cd sr / m^2 */
gsl_const.MKS.PHOT = 1e4 /* cd sr / m^2 */
gsl_const.MKS.FOOTCANDLE = 1.076e1 /* cd sr / m^2 */
gsl_const.MKS.LAMBERT = 1e4 /* cd sr / m^2 */
gsl_const.MKS.FOOTLAMBERT = 1.07639104e1 /* cd sr / m^2 */
gsl_const.MKS.CURIE = 3.7e10 /* 1 / s */
gsl_const.MKS.ROENTGEN = 2.58e-4 /* A s / kg */
gsl_const.MKS.RAD = 1e-2 /* m^2 / s^2 */
gsl_const.MKS.SOLAR_MASS = 1.98892e30 /* kg */
gsl_const.MKS.BOHR_RADIUS = 5.291772083e-11 /* m */
gsl_const.MKS.NEWTON = 1e0 /* kg m / s^2 */
gsl_const.MKS.DYNE = 1e-5 /* kg m / s^2 */
gsl_const.MKS.JOULE = 1e0 /* kg m^2 / s^2 */
gsl_const.MKS.ERG = 1e-7 /* kg m^2 / s^2 */
gsl_const.MKS.STEFAN_BOLTZMANN_CONSTANT = 5.67040047374e-8 /* kg / K^4 s^3 */
gsl_const.MKS.THOMSON_CROSS_SECTION = 6.65245893699e-29 /* m^2 */
gsl_const.MKS.BOHR_MAGNETON = 9.27400899e-24 /* A m^2 */
gsl_const.MKS.NUCLEAR_MAGNETON = 5.05078317e-27 /* A m^2 */
gsl_const.MKS.ELECTRON_MAGNETIC_MOMENT = 9.28476362e-24 /* A m^2 */
gsl_const.MKS.PROTON_MAGNETIC_MOMENT = 1.410606633e-26 /* A m^2 */
gsl_const.MKS.FARADAY = 9.64853429775e4 /* A s / mol */
gsl_const.MKS.ELECTRON_CHARGE = 1.602176487e-19 /* A s */
gsl_const.MKS.VACUUM_PERMITTIVITY = 8.854187817e-12 /* A^2 s^4 / kg m^3 */
gsl_const.MKS.VACUUM_PERMEABILITY = 1.25663706144e-6 /* kg m / A^2 s^2 */
gsl_const.MKS.DEBYE = 3.33564095198e-30 /* A s^2 / m^2 */
gsl_const.MKS.GAUSS = 1e-4 /* kg / A s^2 */

gsl_const.MKSA = {};
gsl_const.MKSA.SPEED_OF_LIGHT = 2.99792458e8 /* m / s */
gsl_const.MKSA.GRAVITATIONAL_CONSTANT = 6.673e-11 /* m^3 / kg s^2 */
gsl_const.MKSA.PLANCKS_CONSTANT_H = 6.62606896e-34 /* kg m^2 / s */
gsl_const.MKSA.PLANCKS_CONSTANT_HBAR = 1.05457162825e-34 /* kg m^2 / s */
gsl_const.MKSA.ASTRONOMICAL_UNIT = 1.49597870691e11 /* m */
gsl_const.MKSA.LIGHT_YEAR = 9.46053620707e15 /* m */
gsl_const.MKSA.PARSEC = 3.08567758135e16 /* m */
gsl_const.MKSA.GRAV_ACCEL = 9.80665e0 /* m / s^2 */
gsl_const.MKSA.ELECTRON_VOLT = 1.602176487e-19 /* kg m^2 / s^2 */
gsl_const.MKSA.MASS_ELECTRON = 9.10938188e-31 /* kg */
gsl_const.MKSA.MASS_MUON = 1.88353109e-28 /* kg */
gsl_const.MKSA.MASS_PROTON = 1.67262158e-27 /* kg */
gsl_const.MKSA.MASS_NEUTRON = 1.67492716e-27 /* kg */
gsl_const.MKSA.RYDBERG = 2.17987196968e-18 /* kg m^2 / s^2 */
gsl_const.MKSA.BOLTZMANN = 1.3806504e-23 /* kg m^2 / K s^2 */
gsl_const.MKSA.MOLAR_GAS = 8.314472e0 /* kg m^2 / K mol s^2 */
gsl_const.MKSA.STANDARD_GAS_VOLUME = 2.2710981e-2 /* m^3 / mol */
gsl_const.MKSA.MINUTE = 6e1 /* s */
gsl_const.MKSA.HOUR = 3.6e3 /* s */
gsl_const.MKSA.DAY = 8.64e4 /* s */
gsl_const.MKSA.WEEK = 6.048e5 /* s */
gsl_const.MKSA.INCH = 2.54e-2 /* m */
gsl_const.MKSA.FOOT = 3.048e-1 /* m */
gsl_const.MKSA.YARD = 9.144e-1 /* m */
gsl_const.MKSA.MILE = 1.609344e3 /* m */
gsl_const.MKSA.NAUTICAL_MILE = 1.852e3 /* m */
gsl_const.MKSA.FATHOM = 1.8288e0 /* m */
gsl_const.MKSA.MIL = 2.54e-5 /* m */
gsl_const.MKSA.POINT = 3.52777777778e-4 /* m */
gsl_const.MKSA.TEXPOINT = 3.51459803515e-4 /* m */
gsl_const.MKSA.MICRON = 1e-6 /* m */
gsl_const.MKSA.ANGSTROM = 1e-10 /* m */
gsl_const.MKSA.HECTARE = 1e4 /* m^2 */
gsl_const.MKSA.ACRE = 4.04685642241e3 /* m^2 */
gsl_const.MKSA.BARN = 1e-28 /* m^2 */
gsl_const.MKSA.LITER = 1e-3 /* m^3 */
gsl_const.MKSA.US_GALLON = 3.78541178402e-3 /* m^3 */
gsl_const.MKSA.QUART = 9.46352946004e-4 /* m^3 */
gsl_const.MKSA.PINT = 4.73176473002e-4 /* m^3 */
gsl_const.MKSA.CUP = 2.36588236501e-4 /* m^3 */
gsl_const.MKSA.FLUID_OUNCE = 2.95735295626e-5 /* m^3 */
gsl_const.MKSA.TABLESPOON = 1.47867647813e-5 /* m^3 */
gsl_const.MKSA.TEASPOON = 4.92892159375e-6 /* m^3 */
gsl_const.MKSA.CANADIAN_GALLON = 4.54609e-3 /* m^3 */
gsl_const.MKSA.UK_GALLON = 4.546092e-3 /* m^3 */
gsl_const.MKSA.MILES_PER_HOUR = 4.4704e-1 /* m / s */
gsl_const.MKSA.KILOMETERS_PER_HOUR = 2.77777777778e-1 /* m / s */
gsl_const.MKSA.KNOT = 5.14444444444e-1 /* m / s */
gsl_const.MKSA.POUND_MASS = 4.5359237e-1 /* kg */
gsl_const.MKSA.OUNCE_MASS = 2.8349523125e-2 /* kg */
gsl_const.MKSA.TON = 9.0718474e2 /* kg */
gsl_const.MKSA.METRIC_TON = 1e3 /* kg */
gsl_const.MKSA.UK_TON = 1.0160469088e3 /* kg */
gsl_const.MKSA.TROY_OUNCE = 3.1103475e-2 /* kg */
gsl_const.MKSA.CARAT = 2e-4 /* kg */
gsl_const.MKSA.UNIFIED_ATOMIC_MASS = 1.660538782e-27 /* kg */
gsl_const.MKSA.GRAM_FORCE = 9.80665e-3 /* kg m / s^2 */
gsl_const.MKSA.POUND_FORCE = 4.44822161526e0 /* kg m / s^2 */
gsl_const.MKSA.KILOPOUND_FORCE = 4.44822161526e3 /* kg m / s^2 */
gsl_const.MKSA.POUNDAL = 1.38255e-1 /* kg m / s^2 */
gsl_const.MKSA.CALORIE = 4.1868e0 /* kg m^2 / s^2 */
gsl_const.MKSA.BTU = 1.05505585262e3 /* kg m^2 / s^2 */
gsl_const.MKSA.THERM = 1.05506e8 /* kg m^2 / s^2 */
gsl_const.MKSA.HORSEPOWER = 7.457e2 /* kg m^2 / s^3 */
gsl_const.MKSA.BAR = 1e5 /* kg / m s^2 */
gsl_const.MKSA.STD_ATMOSPHERE = 1.01325e5 /* kg / m s^2 */
gsl_const.MKSA.TORR = 1.33322368421e2 /* kg / m s^2 */
gsl_const.MKSA.METER_OF_MERCURY = 1.33322368421e5 /* kg / m s^2 */
gsl_const.MKSA.INCH_OF_MERCURY = 3.38638815789e3 /* kg / m s^2 */
gsl_const.MKSA.INCH_OF_WATER = 2.490889e2 /* kg / m s^2 */
gsl_const.MKSA.PSI = 6.89475729317e3 /* kg / m s^2 */
gsl_const.MKSA.POISE = 1e-1 /* kg m^-1 s^-1 */
gsl_const.MKSA.STOKES = 1e-4 /* m^2 / s */
gsl_const.MKSA.STILB = 1e4 /* cd / m^2 */
gsl_const.MKSA.LUMEN = 1e0 /* cd sr */
gsl_const.MKSA.LUX = 1e0 /* cd sr / m^2 */
gsl_const.MKSA.PHOT = 1e4 /* cd sr / m^2 */
gsl_const.MKSA.FOOTCANDLE = 1.076e1 /* cd sr / m^2 */
gsl_const.MKSA.LAMBERT = 1e4 /* cd sr / m^2 */
gsl_const.MKSA.FOOTLAMBERT = 1.07639104e1 /* cd sr / m^2 */
gsl_const.MKSA.CURIE = 3.7e10 /* 1 / s */
gsl_const.MKSA.ROENTGEN = 2.58e-4 /* A s / kg */
gsl_const.MKSA.RAD = 1e-2 /* m^2 / s^2 */
gsl_const.MKSA.SOLAR_MASS = 1.98892e30 /* kg */
gsl_const.MKSA.BOHR_RADIUS = 5.291772083e-11 /* m */
gsl_const.MKSA.NEWTON = 1e0 /* kg m / s^2 */
gsl_const.MKSA.DYNE = 1e-5 /* kg m / s^2 */
gsl_const.MKSA.JOULE = 1e0 /* kg m^2 / s^2 */
gsl_const.MKSA.ERG = 1e-7 /* kg m^2 / s^2 */
gsl_const.MKSA.STEFAN_BOLTZMANN_CONSTANT = 5.67040047374e-8 /* kg / K^4 s^3 */
gsl_const.MKSA.THOMSON_CROSS_SECTION = 6.65245893699e-29 /* m^2 */
gsl_const.MKSA.BOHR_MAGNETON = 9.27400899e-24 /* A m^2 */
gsl_const.MKSA.NUCLEAR_MAGNETON = 5.05078317e-27 /* A m^2 */
gsl_const.MKSA.ELECTRON_MAGNETIC_MOMENT = 9.28476362e-24 /* A m^2 */
gsl_const.MKSA.PROTON_MAGNETIC_MOMENT = 1.410606633e-26 /* A m^2 */
gsl_const.MKSA.FARADAY = 9.64853429775e4 /* A s / mol */
gsl_const.MKSA.ELECTRON_CHARGE = 1.602176487e-19 /* A s */
gsl_const.MKSA.VACUUM_PERMITTIVITY = 8.854187817e-12 /* A^2 s^4 / kg m^3 */
gsl_const.MKSA.VACUUM_PERMEABILITY = 1.25663706144e-6 /* kg m / A^2 s^2 */
gsl_const.MKSA.DEBYE = 3.33564095198e-30 /* A s^2 / m^2 */
gsl_const.MKSA.GAUSS = 1e-4 /* kg / A s^2 */

gsl_const.NUM = {};
gsl_const.NUM.FINE_STRUCTURE = 7.297352533e-3 /* 1 */
gsl_const.NUM.AVOGADRO = 6.02214199e23 /* 1 / mol */
gsl_const.NUM.YOTTA = 1e24 /* 1 */
gsl_const.NUM.ZETTA = 1e21 /* 1 */
gsl_const.NUM.EXA = 1e18 /* 1 */
gsl_const.NUM.PETA = 1e15 /* 1 */
gsl_const.NUM.TERA = 1e12 /* 1 */
gsl_const.NUM.GIGA = 1e9 /* 1 */
gsl_const.NUM.MEGA = 1e6 /* 1 */
gsl_const.NUM.KILO = 1e3 /* 1 */
gsl_const.NUM.MILLI = 1e-3 /* 1 */
gsl_const.NUM.MICRO = 1e-6 /* 1 */
gsl_const.NUM.NANO = 1e-9 /* 1 */
gsl_const.NUM.PICO = 1e-12 /* 1 */
gsl_const.NUM.FEMTO = 1e-15 /* 1 */
gsl_const.NUM.ATTO = 1e-18 /* 1 */
gsl_const.NUM.ZEPTO = 1e-21 /* 1 */
gsl_const.NUM.YOCTO = 1e-24 /* 1 */

module.exports = gsl_const;
